import { buildRegistry, cdnBase, type EagerModule } from '@shared/lib';

const localModules = {
  ...import.meta.glob('../icons/*.svg', { eager: true }),
  ...import.meta.glob('../images/*.webp', { eager: true }),
} as Record<string, EagerModule>;

// CDN base from shared — empty when not configured.
const base = cdnBase();

// always bundled local URLs — used as onError fallback
export const localImages = buildRegistry(localModules);

// CDN URLs when set, else the local ones.
export const allImages = base ? buildRegistry(localModules, base) : localImages;
